import React from 'react'
import { Box, Typography } from '@mui/material'

/**
 * One model parameter's weightage row: label + share-of-total bar + signed impact.
 * `c` is one entry of the /rto/score `all_contributions` array
 * ({ code, label, value, shap_delta, weight_pct, direction }).
 * direction: raises -> red, lowers -> green, neutral -> grey.
 * `dense` tightens it for inline use; full size for the detail card.
 *
 * Ported from the admin panel (proship-backend RtoContributions.js) so the
 * merchant RTO card reads identically.
 */
export const ContributionRow = ({ c, dense }) => {
  const share = Number(c.weight_pct || 0)
  const barColor = c.direction === 'raises' ? '#e53935' : c.direction === 'lowers' ? '#43a047' : '#9e9e9e'
  return (
    <Box sx={{ mb: dense ? 0.5 : 1 }}>
      <Box sx={{ display: 'flex', justifyContent: 'space-between', gap: 1, alignItems: 'baseline' }}>
        <Typography variant='caption' noWrap sx={{ maxWidth: dense ? 150 : 320 }}>{c.label}</Typography>
        <Typography variant='caption' sx={{ whiteSpace: 'nowrap', fontVariantNumeric: 'tabular-nums' }}>
          {share.toFixed(0)}%
          <Box component='span' sx={{ color: 'text.secondary', ml: 0.5 }}>
            ({c.shap_delta > 0 ? '+' : ''}{Number(c.shap_delta).toFixed(2)})
          </Box>
        </Typography>
      </Box>
      <Box sx={{ height: dense ? 4 : 6, borderRadius: 2, bgcolor: 'rgba(0,0,0,0.08)', mt: 0.25 }}>
        <Box sx={{ height: dense ? 4 : 6, borderRadius: 2, width: `${Math.min(share, 100)}%`, bgcolor: barColor }} />
      </Box>
    </Box>
  )
}

export default ContributionRow
